var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  お使いのブラウザでは無理なのです\n  \n  "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("ホーム")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }